import { render, staticRenderFns } from "./TabPane.vue?vue&type=template&id=f3acd1f6&scoped=true"
import script from "./TabPane.vue?vue&type=script&lang=js"
export * from "./TabPane.vue?vue&type=script&lang=js"
import style0 from "./TabPane.vue?vue&type=style&index=0&id=f3acd1f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3acd1f6",
  null
  
)

export default component.exports